import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import MainCard from './MainCard';
import Sidebar from '../JobCardView/Sidebar';

const JobDetailsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Job Details' parent='Job Search' title='Job Details' />
      <Row>
        <Sidebar />
        <MainCard />
      </Row>
    </Container>
  );
};

export default JobDetailsContainer;
